import { render } from "./FollowUpTask.vue?vue&type=template&id=9359bdfe&scoped=true"
import script from "./FollowUpTask.vue?vue&type=script&lang=js"
export * from "./FollowUpTask.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9359bdfe"]])

export default __exports__